import { classed } from '@tw-classed/react'

export const Txt = classed.span('', {
  variants: {
    kind: {
      header: 'text-32 font-bold',
    },
  },
})
